export const DEMO_ACTOR_EMAIL = 'nathan@keyflo.ai';
export const DEMO_SELLER_EMAIL = 'test-sellers@keyflo.ai';

export const LISTING_WIZARD_DEFAULTS = Object.freeze({
  disclose_buyer_broker_comp: 'yes',
  lock_box_authorized: 'yes',
  disclose_offers: 'yes',
  purchase_rsa: 'no',
  protection_period_days: '30',
  lease_period_days: '30',
  commission_structure: 'percent',
});

export function applyListingWizardDefaults(seeded = {}) {
  const next = { ...seeded };
  Object.entries(LISTING_WIZARD_DEFAULTS).forEach(([key, value]) => {
    if (next[key] == null || next[key] === '') next[key] = value;
  });
  return next;
}

export function isDemoActorEmail(email) {
  return (email || '').trim().toLowerCase() === DEMO_ACTOR_EMAIL;
}

export function applyDemoSellerEmails(sellers) {
  return (sellers || []).map((seller) => ({
    name: seller?.name || '',
    email: (seller?.email || '').trim() || DEMO_SELLER_EMAIL,
    phone: seller?.phone || '',
  }));
}

export const LISTING_QUESTION_SKIP_IF = Object.freeze({
  rsa_cost: (values) => values?.purchase_rsa === 'no',
  commission_percent: (values) => values?.commission_structure === 'fixed',
  commission_amount: (values) => values?.commission_structure === 'fixed'
    ? false
    : true,
});

export function shouldSkipListingQuestion(question, values) {
  const skipIf = question?.skipIf || LISTING_QUESTION_SKIP_IF[question?.id];
  return typeof skipIf === 'function' && !!skipIf(values);
}

export function firstVisibleListingStepIndex(questions, startIndex, values) {
  let index = Math.max(0, startIndex || 0);
  while (index < questions.length && shouldSkipListingQuestion(questions[index], values)) {
    index += 1;
  }
  if (index >= questions.length) {
    return lastVisibleListingStep(questions, values);
  }
  return index;
}

export function nextVisibleListingStep(questions, from, values, direction) {
  let index = from + direction;
  while (index >= 0 && index < questions.length) {
    if (!shouldSkipListingQuestion(questions[index], values)) return index;
    index += direction;
  }
  return from;
}

export function lastVisibleListingStep(questions, values) {
  for (let index = questions.length - 1; index >= 0; index -= 1) {
    if (!shouldSkipListingQuestion(questions[index], values)) return index;
  }
  return 0;
}

export function visibleListingStepLabel(questions, currentStep, values) {
  let visible = 0;
  let total = 0;
  questions.forEach((question, index) => {
    if (shouldSkipListingQuestion(question, values)) return;
    total += 1;
    if (index <= currentStep) visible += 1;
  });
  return { visible: Math.max(visible, 1), total: Math.max(total, 1) };
}
